import { gql } from '@apollo/client';

export const UPSERT_SURVEY_ANSWERS = gql`
  mutation upsertSurveyAnswers($input: UpsertSurveyAnswerInput!) {
    workspaceForm: upsertSurveyAnswers(input: $input) {
      id
    }
  }
`;
